import { Col, Row } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { KanbanContext } from "..";

type Props = {
  children: React.JSX.Element[];
};

export const KanbanLayout = observer((props: Props) => {
  const kanbanManager = React.useContext(KanbanContext);

  const span =
    kanbanManager.viewType === "list"
      ? { span: 24 }
      : { xxl: 6, xl: 8, lg: 12, md: 12, sm: 24, xs: 24 };

  return (
    <Row align="stretch" gutter={[16, 16]}>
      {props.children.map((child) => (
        <Col {...span} key={child.key}>
          {child}
        </Col>
      ))}
    </Row>
  );
});
